import React, { memo } from "react";
import { THEME, ThemeManager } from "@disco/disco_core";
import BaseApp from "./BaseApp";
import {
	CacheManager,
	DataManager,
	ModeManager,
	PDPManager,
	TrackingManager,
	VisibleGroupsManager,
	UserManager,
	PingManager,
	ViewportManager,
	IntersectionManager,
	ImpressionManager,
	PreviewManager,
} from "./components/managers";

const App = memo(({ children, mock = false }) => {
	return (
		<ThemeManager defaultTheme={THEME.SHOP_DISCO}>
			<DataManager mock={mock}>
				<CacheManager>
					<PingManager>
						<PreviewManager>
							<ViewportManager>
								<ImpressionManager>
									<IntersectionManager>
										<UserManager>
											<ModeManager>
												<VisibleGroupsManager>
													<TrackingManager>
														<PDPManager>
															{children || (
																<BaseApp />
															)}
														</PDPManager>
													</TrackingManager>
												</VisibleGroupsManager>
											</ModeManager>
										</UserManager>
									</IntersectionManager>
								</ImpressionManager>
							</ViewportManager>
						</PreviewManager>
					</PingManager>
				</CacheManager>
			</DataManager>
		</ThemeManager>
	);
});
export default App;
